<template>
  <div>
    <DialogPrime
      :header="$t('addAuxEngineEnergeSavingsComponentHeader')"
      v-model:visible="displayBasic"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '75vw' }"
    >
      <div class="formgrid grid">
        <div class="field col-12 md:col-4">
          <p>{{ $t("energyEfficiency") }}</p>
          <DropdownPrime
            id="type"
            v-model="type"
            :options="measureTypeOptions"
            optionLabel="name"
            placeholder="Energy efficiency technologies"
            class="field col-12"
          ></DropdownPrime>
        </div>
        <div v-if="type && type.code === 'SLC'" class="field col-12 md:col-4">
          <label for="feffpaeeff">{{ $t("feffpaeeff") }} - <strong>feff·PAEeff</strong> (kW)</label>
          <InputTextPrime
            id="feffpaeeff"
            v-model="feffpaeeff"
            class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          />
        </div>
        <div v-if="type && type.code === 'WERS'" class="field col-12 md:col-4">
          <label for="feffpaeeff">{{ $t("feffpaeeff2") }} - <strong>feff·PAEeff</strong> (kW).</label>
          <InputTextPrime
            id="feffpaeeff"
            v-model="feffpaeeff"
            class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          />
        </div>
      </div>
      <template #footer>
        <ButtonPrime :label="$t('cancel')" icon="pi pi-times" @click="closeBasic" class="p-button-text" />
        <ButtonPrime :label="$t('confirm')" icon="pi pi-check" @click="saveAndClose" autofocus />
      </template>
    </DialogPrime>
  </div>
</template>

<script>
import store from "@/store/index";
import ShipPartService from "@/services/ShipPartService";
import ParametricTableService from "@/services/ParametricTableService";
import { config } from "@/utils/configuration/config";

export default {
  name: "AddAuxEngineEnergySavingsComponent",
  data: () => {
    return {
      displayBasic: false,
      id: "",
      type: "",
      measureTypeOptions: [],
      feffpaeeff: 0,
    };
  },
  props: {
    editElementId: Object,
  },

  watch: {
    editElementId: function (newVal) {
      // watch it
      //console.log("Prop changed: ", newVal, " | was: ", oldVal);
      this.id = newVal.id;
      this.feffpaeeff = newVal.feffpaeeff;

      this.type = this.findElementInOptions(newVal.type, this.measureTypeOptions);

      this.displayBasic = true;
    },
  },

  created() {
    ParametricTableService.getInstance().getParametricTable(config.firebaseConfig.parametricVersion);
  },
  mounted() {
    console.log(
      "Parametric",
      ParametricTableService.getInstance().getParametricTable(config.firebaseConfig.parametricVersion)
    );
    this.measureTypeOptions = ParametricTableService.getInstance().getParametricTable(
      config.firebaseConfig.parametricVersion
    ).auxiliaryEngineEnergyEfficiencyMeasureType;
  },
  methods: {
    closeBasic() {
      this.displayBasic = false;
    },
    saveAndClose() {
      //console.log("AddShipPartComponent-saveAndClose", this.name);
      const newPart = {
        id: this.id,
        type: this.type.code,
        feffpaeeff: this.feffpaeeff ? this.feffpaeeff : 0,
      };

      const errors = ShipPartService.getInstance().saveAuxEngineEnergySavingsPart(
        store.getters.currentShip.id,
        store.getters.currentConfiguration.id,
        newPart
      );

      if (errors === "") {
        this.displayBasic = false;
        this.$emit(
          "savedElement",
          "Innovative auxiliary motor electrical energy efficiency technologies",
          !this.id || this.id === ""
        );
      } else {
        this.$emit(
          "errorSavingElement",
          "Innovative auxiliary motor electrical energy efficiency technologies",
          errors
        );
      }
    },
    editConfig() {
      //console.log("editConfig");
      this.displayBasic = true;
    },
    findElementInOptions(code, options) {
      var result = {};
      options.forEach((option) => {
        if (option.code === code) {
          result = option;
        }
      });
      return result;
    },
  },
};
</script>

<style scoped>
.p-button {
  margin: 10px !important;
}
.field {
  margin-bottom: 15px !important;
}
</style>
